(() => {
  function initialiseFitGuides() {
    document.querySelectorAll('[data-jacu-fit]').forEach(guide => {
      if (guide.dataset.fitReady) return;
      const picker = guide.querySelector('.jacu-fit-picker');
      const select = picker && picker.querySelector('select');
      const designers = [...guide.querySelectorAll('[data-fit-designer]')];
      if (!select) return;
      guide.dataset.fitReady = 'true';
      picker.hidden = false;
      const applySelection = () => {
        designers.forEach(designer => {
          const selected = designer.dataset.fitDesigner === select.value;
          designer.hidden = Boolean(select.value) && !selected;
          designer.open = selected;
        });
      };
      select.addEventListener('change', applySelection);
      const initial = guide.dataset.fitInitial;
      if (initial && [...select.options].some(option => option.value === initial)) {
        select.value = initial;
        applySelection();
      }
    });
  }
  initialiseFitGuides();
  document.addEventListener('shopify:section:load', initialiseFitGuides);
})();
